import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { useDeleteGoalMutation } from '../../api/useDeleteGoalMutation';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';

interface Props {
  clientId: string;
  goalId: string;
  onClose(): void;
  onSuccess(): void;
}

export const DeleteGoalModal = ({ clientId, goalId, onClose, onSuccess }: Props) => {
  const {
    mutateAsync: deleteGoalMutation,
    isLoading: isDeletingGoal,
    error: deleteGoalError,
  } = useDeleteGoalMutation({ clientId });

  const handleDeleteGoal = async () => {
    try {
      await deleteGoalMutation({ clientId, goalId });

      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'delete-goal-modal--header' }}
    >
      <ModalHeader id="delete-goal-modal--header">
        Are you sure you want to remove this goal?
      </ModalHeader>

      {deleteGoalError && (
        <Alert message={deleteGoalError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>This action cannot be undone.</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose} mr="8">
          Cancel
        </Button>

        <Button isLoading={isDeletingGoal} variant="error" onClick={handleDeleteGoal}>
          Remove Goal
        </Button>
      </ModalFooter>
    </Modal>
  );
};
